const initialState = {
    changedAccidentalCaseStatus : [],
    loadingAccidentalCase: false,
    errorsAccidentalCase: {},
}

const  accidentalCaseReducer = (state = initialState, action) => {
    switch (action.type) {
        case "CREATE_INCIDENTAL_PENDING":
        case "CREATE_SPOT_VISIT_PENDING":
        case "CREATE_POLICE_STATION_PENDING":
        case "CREATE_MLC_PENDING":
        case "CREATE_VILLAGE_AUTHORITIES_PENDING":
        case "CREATE_DEATH_CERTIFICATE_PENDING":
        case "CREATE_CREMATION_CERTIFICATE_PENDING":
            return { ...state, loadingAccidentalCase: true };
        
        case "CREATE_INCIDENTAL_FULFILLED":
            return { ...state, loadingAccidentalCase: false, changedAccidentalCaseStatus: action.payload };
        case "CREATE_SPOT_VISIT_FULFILLED":
            return { ...state, loadingAccidentalCase: false, changedAccidentalCaseStatus: action.payload };
        case "CREATE_POLICE_STATION_FULFILLED":
            return { ...state, loadingAccidentalCase: false, changedAccidentalCaseStatus: action.payload };
        case "CREATE_MLC_FULFILLED":
            return { ...state, loadingAccidentalCase: false, changedAccidentalCaseStatus: action.payload };
        case "CREATE_DEATH_CERTIFICATE_FULFILLED":
            return { ...state, loadingAccidentalCase: false, changedAccidentalCaseStatus: action.payload };
        case "CREATE_CREMATION_CERTIFICATE_FULFILLED":
            return { ...state, loadingAccidentalCase: false, changedAccidentalCaseStatus: action.payload };
        case "CREATE_VILLAGE_AUTHORITIES_FULFILLED":
            return { ...state, loadingAccidentalCase: false, changedAccidentalCaseStatus: action.payload };
        
        case "CREATE_INCIDENTAL_REJECTED":
            return { ...state, loadingAccidentalCase: false, errorsAccidentalCase: action.payload };
        case "CREATE_SPOT_VISIT_REJECTED":
            return { ...state, loadingAccidentalCase: false, errorsAccidentalCase: action.payload };
        case "CREATE_POLICE_STATION_REJECTED":
            return { ...state, loadingAccidentalCase: false, errorsAccidentalCase: action.payload };
        case "CREATE_MLC_REJECTED":
            return { ...state, loadingAccidentalCase: false, errorsAccidentalCase: action.payload };
        case "CREATE_DEATH_CERTIFICATE_REJECTED":
            return { ...state, loadingAccidentalCase: false, errorsAccidentalCase: action.payload };
        case "CREATE_CREMATION_CERTIFICATE_REJECTED":
            return { ...state, loadingAccidentalCase: false, errorsAccidentalCase: action.payload };
        case "CREATE_VILLAGE_AUTHORITIES_REJECTED":
            return { ...state, loadingAccidentalCase: false, errorsAccidentalCase: action.payload };
        
        case "RESET_CREATE_INCIDENTAL_STATUS":
            return { ...state, changedAccidentalCaseStatus: {} };
        case "RESET_ACCIDENTAL_CASE_ERRORS":
            return { ...state, errorsAccidentalCase: {} };
        default:
            return state;
    }
}

export default accidentalCaseReducer;